import {$authHost} from "../http/axios";

export default class CompareService {
    static compare = async (labeledDescriptors, distance) => {
        const {data} = await $authHost.post('/compare', {array: JSON.stringify(labeledDescriptors), distance});
        return data;
    }
}